<template>
  <div class="col-md-12 col-lg-4 mb-3 mb-lg-0 w4" v-if="contract">
    <div class="card h-100">
      <div class="card-header">
        <h2>Contracts</h2>
      </div>
      <hr width="95%" class="mt-0 ml-3 mb-2" />
      <div class="card-body text-center">
        <div class="row">
          <div class="col-sm-12">
            <div class="table-div mt-3">
              <b-table
                id="contracts_table"
                class="hover-faded"
                hover
                striped
                :fields="contractFields"
                :items="orderByStartDate(contracts)"
                :tbody-tr-class="isCurrentContract"
                per-page="6"
                @row-clicked="showPanel"
              >
                <template slot="Starts" slot-scope="data">{{data.item.StartDate | shortDate}}</template>
                <template slot="Ends" slot-scope="data">{{data.item.EndDate | shortDate}}</template>
                <template slot="EndsIn" slot-scope="data">
                  <div v-if="isExpired(data.item)">
                    Ended
                    {{data.item.EndDate | timefromNow}}
                  </div>
                  <div v-else>
                    Ends {{data.item.EndDate | timefromNow}}
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <!-- <div class="col-sm-12">
          <a class="btn btn-hc m-20" role="button" @click="showPanel">View Contracts</a>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import ContractsPanel from "@/components/panels/contracts-panel-components/ContractsPanel";
import moment from "moment";
import _filters from "@/mixins/filters.js";

export default {
  mixins: [_filters],
  data() {
    return {
      contractFields: {
        Starts: {
          label: "Start Date",
          sortable: true,
        },
        Ends: {
          label: "End Date",
        },
        EndsIn: {
          label: "",
        },
      },
    };
  },

  methods: {
    orderByStartDate(collection) {
      return this.$_.sortBy(collection, function (item) {
        return item.StartDate;
      }).reverse();
    },
    isCurrentContract(item, type) {
      if (!item || type !== "row") return;
      if (item === this.$store.state.contracts.contract)
        return "currentContract";
    },
    showPanel(contract) {
      this.$store.state.contracts.activeContract = contract;
      this.$showPanel({
        component: ContractsPanel,
        openOn: "right",
        cssClass: "contracts-panel",
        props: {
          //any data you want passed to your component
        },
      });
    },
    isExpired(contract) {
      return moment().isSameOrAfter(moment(contract.EndDate).add(1, "days"));
    },
  },
  computed: {
    contract() {
      return this.$store.state.contracts.contract;
    },
    contracts() {
      return this.$store.state.contracts.contracts;
    },
    // progress() {
    //   if (this.contract) {
    //     if (this.$store.getters.progress >= 100) {
    //       return 100;
    //     }
    //     return this.$store.getters.progress;
    //   }
    // }
  },
};
</script>

<style lang="css">
#contracts_table tbody tr.currentContract {
  background-color: var(--primary);
}
</style>